export const ROUTE_PATHS = {
  HOME: '/'
} as const;

export const SECTIONS = {
  HERO: 'hero',
  INTRO: 'intro',
  PROBLEMATIQUES: 'problematiques',
  FORMATIONS: 'formations',
  POUR_QUI: 'pour-qui',
  BENEFICES: 'benefices',
  CREDIBILITE: 'credibilite',
  METHODE: 'methode',
  CONTACT: 'contact'
} as const;

export interface Formation {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  benefits: string[];
  ctaText: string;
  ctaLink: string;
  gradient: string;
}

export const FORMATIONS_DATA: Formation[] = [
  {
    id: 'ia-coiffeurs',
    title: 'Formation IA pour les Coiffeurs',
    subtitle: 'Maîtrisez l\'intelligence artificielle au quotidien',
    description: 'Apprenez à utiliser l\'IA pour transformer votre pratique professionnelle et gagner en efficacité.',
    benefits: [
      'Gain de temps considérable sur les tâches répétitives',
      'Création de contenus marketing impactants',
      'Amélioration de votre communication client',
      'Génération d\'idées créatives pour vos services',
      'Structuration optimisée de votre activité',
      'Utilisation concrète de l\'IA dans votre métier'
    ],
    ctaText: 'Découvrir la formation IA',
    ctaLink: '#contact',
    gradient: 'from-primary/20 via-accent/10 to-primary/20'
  },
  {
    id: 'pilotage-salon',
    title: 'Formation Pilotage de Salon avec IA',
    subtitle: 'Dirigez votre salon avec clarté et performance',
    description: 'Développez une vision stratégique et pilotez votre salon avec méthode grâce à l\'intelligence artificielle.',
    benefits: [
      'Lecture claire et précise de votre activité',
      'Suivi optimisé de vos indicateurs clés',
      'Aide à l\'analyse et à la prise de décision',
      'Vision dirigeant structurée et efficace',
      'Organisation modernisée de votre salon',
      'Décisions éclairées basées sur les données'
    ],
    ctaText: 'Découvrir la formation Pilotage',
    ctaLink: '#contact',
    gradient: 'from-accent/20 via-primary/10 to-accent/20'
  }
];

export const PROBLEMATIQUES = [
  {
    id: 'temps',
    title: 'Manque de temps',
    description: 'Débordé par les tâches quotidiennes, difficile de prendre du recul'
  },
  {
    id: 'methode',
    title: 'Manque de méthode',
    description: 'Absence de structure claire pour organiser et développer l\'activité'
  },
  {
    id: 'chiffres',
    title: 'Difficulté à suivre les chiffres',
    description: 'Pilotage à l\'aveugle sans vision claire de la performance'
  },
  {
    id: 'communication',
    title: 'Communication non structurée',
    description: 'Présence digitale faible, messages peu impactants'
  },
  {
    id: 'outils',
    title: 'Retard sur les nouveaux outils',
    description: 'Difficulté à intégrer les technologies modernes'
  },
  {
    id: 'ia',
    title: 'IA encore floue',
    description: 'Incompréhension de l\'IA et de son utilisation concrète'
  }
];

export const BENEFICES = [
  'Gagner du temps au quotidien',
  'Mieux communiquer avec vos clients',
  'Clarifier votre organisation',
  'Utiliser l\'IA de manière concrète',
  'Prendre de meilleures décisions',
  'Avoir plus de recul sur votre activité',
  'Moderniser votre salon',
  'Mieux piloter au quotidien'
];

export const CIBLES = [
  'Coiffeurs professionnels',
  'Dirigeants de salon',
  'Responsables d\'équipe',
  'Salons souhaitant évoluer',
  'Professionnels voulant intégrer l\'IA',
  'Salons voulant mieux piloter leur activité'
];

export const CREDIBILITE_POINTS = [
  {
    title: 'Expérience terrain',
    description: 'Connaissance approfondie du secteur de la coiffure'
  },
  {
    title: 'Spécialisation coiffure',
    description: 'Formations adaptées aux réalités du métier'
  },
  {
    title: 'Approche concrète',
    description: 'Outils et méthodes directement applicables'
  },
  {
    title: 'Pédagogie claire',
    description: 'Transmission accessible et structurée'
  },
  {
    title: 'Modernité',
    description: 'Vision tournée vers l\'avenir du secteur'
  },
  {
    title: 'Proximité',
    description: 'Compréhension des problématiques du terrain'
  }
];

export const METHODE_POINTS = [
  'Formation concrète et opérationnelle',
  'Exemples réels tirés du secteur',
  'Outils directement utilisables',
  'Approche accessible à tous',
  'Application immédiate au terrain',
  'Vision orientée action et résultats'
];

export const CONTACT_INFO = {
  whatsapp: '+33604417682',
  whatsappFormationIA: 'https://wa.me/33604417682?text=Bonjour%20Loris%2C%20je%20souhaite%20en%20savoir%20plus%20sur%20l%27intelligence%20artificielle%20pour%20mon%20salon.',
  whatsappFormationPilotage: 'https://wa.me/33604417682?text=Bonjour%20Loris%2C%20je%20souhaite%20am%C3%A9liorer%20le%20pilotage%20et%20la%20rentabilit%C3%A9%20de%20mon%20salon',
  email: 'contact@lorishug.fr',
  instagram: 'lorishug',
  linkedin: 'loris-hug'
};